<rs-top-bar-menu
  [application]="'ORD ADMIN'"
  [menuItems]="menuItems()"
/>

<rs-loader />

<router-outlet />

<rs-footer />